import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '../../components/AppLayout';
import ProjectLayout from '../../components/ProjectLayout';
import { FullScreenLoader, Loading, RequireAuth } from '../../components/routing';
import { useAuth } from '../../lib/auth';
import LoginPage from '../../pages/LoginPage';
import ProjectsPage from '../../pages/ProjectsPage';

/**
 * The viewing surface — app.windysignal.com.
 *
 * Deliberately only the screens you read: a project's overview and its
 * dashboards. Nothing that edits how a project is built is imported here, so
 * the builder's React Flow canvas and CodeMirror editors never reach this
 * bundle at all.
 */
const DashboardListPage = lazy(() => import('../../pages/DashboardListPage'));
const DashboardViewPage = lazy(() => import('../../pages/DashboardViewPage'));
const OverviewPage = lazy(() => import('../../pages/OverviewPage'));

export default function App() {
  const { user, loading } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={loading ? <FullScreenLoader /> : user ? <Navigate to="/" replace /> : <LoginPage />}
      />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<ProjectsPage />} />

        <Route path="projects/:projectId" element={<ProjectLayout />}>
          <Route
            index
            element={
              <Loading>
                <OverviewPage />
              </Loading>
            }
          />
          <Route
            path="dashboards"
            element={
              <Loading>
                <DashboardListPage />
              </Loading>
            }
          />
          <Route
            path="dashboards/:dashboardId"
            element={
              <Loading label="Loading dashboard">
                <DashboardViewPage />
              </Loading>
            }
          />
        </Route>
      </Route>

      {/* Anything that only exists on the builder lands back on the project list. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
